import React, { PropTypes, Component } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import { updatePassword } from '../../sources/AuthSources'
import AuthActions from '../../actions/AuthActions'
import Input from '../../components/Input'
import Button from '../../components/Button'
import Grid, { Half } from 'grid-styled'
import { Metrics, Colors } from '../../Themes'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'

const Container = styled.div`
  margin-top: ${Metrics.margins.larger};
  height: calc(
    100vh - (${Metrics.components.navbarDefault} + ${Metrics.margins.big})
  );
  position: relative;
`

const CustomButton = styled(Button)`
  float: right;
  margin-top: ${Metrics.margins.larger};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    text-align: center;
    margin-top: 0;
    position: absolute;
    bottom: ${Metrics.margins.base};
    background: ${Colors.primary};
    color: ${Colors.whiteThree};
    float: inherit;
    width: 100%;
  }
`

const CustomHalf = styled(Half)`
  padding-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}){
    padding-left: 0;
    padding-right: 0;
  }
`

const CustomGrid = styled(Grid)`
  padding-top: ${Metrics.margins.base};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}){
    padding-left: 0;
    padding-right: 0;
  }
`

class Security extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: this.props.user,
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      modal: false,
      validInput: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleChange ({ key, evt }) {
    const validInput =
      this.state.newPassword.length > 0 &&
      this.state.confirmNewPassword.length > 0 &&
      this.state.currentPassword === this.state.confirmNewPassword &&
      this.state.currentPassword.length > 0
    this.setState({
      [key]: evt.target.value,
      validInput
    })
  }

  handleSubmit () {
    updatePassword(this.state.currentPassword, this.state.newPassword)
      .then(response => {
        this.setState(
          {
            modal: 'success',
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: ''
          },
          () => AuthActions.updateToken(response.data.authToken)
        )
      })
      .catch(error => {
        console.log(error)
        this.setState({
          modal: 'error',
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: ''
        })
      })
  }

  handleClose () {
    this.setState({ modal: false })
  }

  render () {
    const { t } = this.props
    const { modal } = this.state
    return (
      <Container>
        <SuccessModal
          visible={modal === 'success'}
          closeAction={this.handleClose}
          header={t('Password Updated')}
          message={t('Your password was successfully updated')}
        />
        <ErrorModal
          visible={modal === 'error'}
          closeAction={this.handleClose}
          header={t('Error')}
          message={t('There was an error when updating your password')}
        />
        <CustomHalf noPadTop>
          <Input
            placeholder={t('Insert Old Password')}
            type='password'
            title={t('Old Password')}
            handleChange={event =>
              this.handleChange({ key: 'currentPassword', evt: event })}
            value={this.state.currentPassword}
          />
        </CustomHalf>
        <div>
          <CustomHalf>
            <Input
              type='password'
              placeholder={t('Insert new Password')}
              title={t('New Password')}
              handleChange={event =>
                this.handleChange({ key: 'newPassword', evt: event })}
              value={this.state.newPassword}
            />
          </CustomHalf>
          <CustomHalf>
            <Input
              type='password'
              placeholder={t('Confirm Old Password')}
              title={t('Confirm New Password')}
              handleChange={event =>
                this.handleChange({ key: 'confirmNewPassword', evt: event })}
              value={this.state.confirmNewPassword}
            />
          </CustomHalf>
        </div>
        <CustomGrid>
          <CustomButton label={t('Save')} onClick={this.handleSubmit} />
        </CustomGrid>
      </Container>
    )
  }
}

Security.propTypes = {
  user: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'settings' ], { wait: true })(Security)



// WEBPACK FOOTER //
// ./src/pages/ProfileSettings/Security.js